const CONFIG = {
  ENVIRONMENT: process.env.NODE_ENV,
  API: {
    BASE_URL: process.env.REACT_APP_API_URL,
  },
  TELEGRAM: {
    BOT_USERNAME: process.env.REACT_APP_TELEGRAM_BOT_USERNAME,
  },
};

export default CONFIG;
